module.exports = __webpack_public_path__ + "static/media/apocalypse.3129fba5.jpg";